<div class="mat-dialog-title">
  <p>DESBLOQUEIO DE CARTÃO</p>
</div>

<div class="mat-dialog-content">
  <div class="beneficiary-infos">
    <div class="data-container">
      <p class="title">{{ isBeneficiary() ? "Beneficiário" : "Dependente" }}</p>
      <p class="value">{{ getName() }}</p>
    </div>

    <div class="data-container">
      <p class="title">Número do cartão</p>
      <p class="value">{{ getCardNumber() | cardNumberFormat }}</p>
    </div>
  </div>

  <form>
    <mat-checkbox *ngIf="isBeneficiary()" [formControl]="includeDependetsFormControl">Incluir dependentes no desbloqueio?</mat-checkbox>
  </form>
</div>

<div class="mat-dialog-actions">
  <button mat-flat-button class="cancel-btn" (click)="closeDialog()">CANCELAR</button>

  <button mat-flat-button class="block-btn" (click)="unblockBeneficiaryCard()">DESBLOQUEAR</button>
</div>
